import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { fmtDate } from "@/lib/utils2";

export default function AuditLog() {
  const { t, lang } = useApp();
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    api.get("/audit").then((r) => setLogs(r.data)).catch((e) => {
      if (e?.response?.status === 403) setDenied(true);
    });
  }, []);

  return (
    <div className="space-y-4" data-testid="audit-page">
      <div className="flex items-center gap-2">
        <button onClick={() => navigate("/more")} className="h-9 w-9 rounded-full bg-secondary flex items-center justify-center" data-testid="audit-back">
          <Icons.ArrowLeft className="h-5 w-5 rtl:rotate-180" />
        </button>
        <h1 className="text-2xl font-bold">{t("audit_log")}</h1>
      </div>
      {denied ? (
        <div className="py-16 flex flex-col items-center text-center gap-3" data-testid="audit-denied">
          <div className="h-16 w-16 rounded-full bg-destructive/10 flex items-center justify-center">
            <Icons.ShieldAlert className="h-8 w-8 text-destructive" />
          </div>
          <p className="text-muted-foreground font-medium max-w-xs">{t("access_denied")}</p>
        </div>
      ) : (
      <div className="space-y-2">
        {logs.map((l) => (
          <div key={l.id} className="rounded-xl bg-card border border-border p-3 flex items-center gap-3" data-testid={`audit-${l.id}`}>
            <Icons.ShieldCheck className="h-5 w-5 text-brand dark:text-primary shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm">{l.action} · {l.entity}</p>
              <p className="text-xs text-muted-foreground">{l.user_name} · {l.details}</p>
            </div>
            <p className="text-xs text-muted-foreground whitespace-nowrap">{fmtDate(l.timestamp, lang)}</p>
          </div>
        ))}
        {logs.length === 0 && <p className="py-10 text-center text-muted-foreground">{t("empty_generic")}</p>}
      </div>
      )}
    </div>
  );
}
